var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { colors } from '../../abstracts';
import { MapPinElement, Circle, Triangle, IconWrapper, AsurionIcon, TextElement, } from './elements';
export var MapPin = forwardRef(function (_a, fRef) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.variant, variant = _c === void 0 ? 'logo' : _c, _d = _a.isSelected, isSelected = _d === void 0 ? false : _d, ariaLabel = _a.ariaLabel, _e = _a.color, color = _e === void 0 ? 'primary' : _e, label = _a.label, rest = __rest(_a, ["size", "variant", "isSelected", "ariaLabel", "color", "label"]);
    var renderIcon = function () { return (React.createElement(IconWrapper, { "$size": size },
        React.createElement(AsurionIcon, { "$size": size, src: "AsurionLogo", fill: colors.white }))); };
    return (React.createElement(InternalProvider, null,
        React.createElement(MapPinElement, __assign({ ref: fRef, "aria-label": ariaLabel || (variant === 'logo' && 'Map pin') || label, "$pinVariant": variant, "$color": color, "$size": size, "$selected": isSelected, "$label": label }, rest),
            React.createElement(Circle, { "$pinVariant": variant, "$color": color, "$size": size, "$selected": isSelected, "$label": label },
                variant === 'logo' && renderIcon(),
                variant !== 'logo' && React.createElement(TextElement, null, label)),
            React.createElement(Triangle, { "$label": label, "$pinVariant": variant, "$color": color, "$size": size, "$selected": isSelected }))));
});
